import React from 'react';
import SMBaloonBaseView from 'components/shared/SMBaloonBaseView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMOwnerBaloonView extends SMBaloonBaseView {
  
  render() {
    const owner = this.props.owner;
    let authRows = [];
    if (owner.is_verified_email) {
      authRows.push(<p key="email" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000095")}</p>);
    }
    if (owner.is_verified_tel) {
      authRows.push(<p key="tel" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000096")}</p>);
    }
    return (
      <div ref="baloon" className="baloon baloon-top owner-detail-baloon" 
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <div className="baloon-inner">
          <img src={SMFormatHelper.ownerImageUrl(owner, owner.profile_image)} className="user-detail-baloon__img" alt={SMFormatHelper.ownerName(owner)} />
          <p className="user-detail-baloon__name">{SMFormatHelper.ownerName(owner)}</p>
          {authRows}
          <a target="_blank" href={this.props.buttonLink} className="button-blue user-detail-baloon__button">{this.props.buttonTitle}</a>
        </div>
      </div>
    );
  }
}
export default SMOwnerBaloonView;



// WEBPACK FOOTER //
// ./app/javascript/components/owners/SMOwnerBaloonView.jsx